<template>
    <div>
        <v-server-table
            ref="table"
            :columns="columns"
            :options="options"
            :url="route('application-activities.table', { 'relation': entityId })"
            class="trigger activities-server-table"
        >
            <template slot="done_at" slot-scope="{ row }">
                <span>{{ row.done_at | date }}</span>
            </template>
            <template slot="organisation" slot-scope="{ row }">
                {{ row.organisation }}
            </template>
            <template slot="position" slot-scope="{ row }">
                {{ row.position }}
            </template>
            <template slot="type" slot-scope="{ row }">
                {{ row.type.value }}
            </template>
            <template slot="status" slot-scope="{ row }">
                {{ row.status.value }}
            </template>
            <template slot="next_action" slot-scope="{ row }">
                {{ row.next_action }}
            </template>
        </v-server-table>
    </div>
</template>

<script>
    import { Actions } from "~/components/tables/application-activities";
    import { TableMixin } from "~/mixins/table";

    export default {
        name: "applicationActivitiesTable",
        mixins: [TableMixin],

        props: {
            entityId: {
                type: Number,
                required: true,
            },
            columns: {
                type: Array,
                default: () => ["done_at", "organisation", "position", "type", "status", "next_action", "actions"],
            },
            filterable: {
                type: Array,
                default: () => ["done_at", "organisation", "position", "type", "status", "next_action",],
            },
            forceRefresh: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                hasTouched: false,
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        done_at: this.uLang("app.date_application_activity"),
                        organisation: this.uLang("app.organisation"),
                        position: this.uLang("app.position"),
                        type: this.uLang("app.application_activity"),
                        status: this.uLang("app.status"),
                        next_action: this.uLang("app.next_action"),
                        actions: this.uLang('app.actions'),
                    },
                    texts: {
                        noResults: this.uLang('app.no_application_activities'),
                    }
                },
            };
        },

        watch: {
            forceRefresh() {
                if (this.forceRefresh === true) {
                    this.$refs.table.refresh();
                    this.$emit("refreshed");
                }
            },
        },
    };
</script>

<style lang="scss">
    .activities-server-table thead tr th {
        width: 16%;
    }

    .activities-server-table thead tr th:first-child {
        width: 13%
    }

    .activities-server-table thead tr th:nth-child(5) {
        width: auto;
    }

    .activities-server-table thead tr th:nth-child(6) {
        width: 50%;
    }

    .activities-server-table thead tr th:last-child {
        width: 11%;
    }


    .activities-server-table tbody tr td:first-child {
        text-transform: capitalize;
    }

    .activities-server-table tbody tr td:nth-child(6) {
        word-break: break-all;
    }

    .activities-server-table tbody tr td:first-letter {
        text-transform: uppercase;
    }
</style>
